import React from "react";
import { FiArrowDown } from "react-icons/fi";
import "./login.css";
import logo from "../../assets/logo.jpg";
import { useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { useAuth } from "../../Auth/FAuth";

function LoginIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const routeMatch = useRouteMatch();
  const history = useHistory();
  const [error, setError] = useState("");
  const [err, setErr] = useState(false);
  const { currentUser, FLogin } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email && password) {
      try {
        FLogin(email, password);
        history.replace("/");
      } catch (error) {
        setError(error.message);
        alert("Check connection or input credentials");
      }

      setEmail("");
      setPassword("");
    } else {
      alert("Empty input Enter details to login");

    }
  };

  return (
    <div className="login-container">
      <div className="title">
        <h1>WELCOME TO</h1>
        <h2>NORTHWAY COMMERCE HUB</h2>

      </div>
      <div className="admin-info">
        <div className="logo">
          <img src={logo} alt="" />
        </div>
        <div className="pointer">
          <h4>Login</h4>

          <FiArrowDown className="icon" />

        </div>
      </div>
      <form className="login" onSubmit={handleSubmit}>
        <label htmlFor="email">Email</label>
        <input
          type="email"
          name="email"
          id="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          placeholder="Email"
          className="form-input"
        />
        <label htmlFor="password">Password</label>
        <input
          type="password"
          name="password"
          id="password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          placeholder="Password"
          className="form-input"
        />
        <div className="btn-container">
          <button className="lgn-btn" type="submit">
            LOGIN
          </button>
        </div>
      </form>
    </div>
  );
}

export default LoginIn;
